<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="transactionlist-transaction-container" v-if="transaction">
      <transition name="fade">
        <div class="transactionlist-transaction" v-show="transaction">
          <h3><i class="fa fa-fw fa-file"></i> {{ _('Transaction') }} {{ transaction.id }}</h3>
          <div>{{ transactionFullDate }}</div>
          <div v-if="transaction.name">{{ transaction.name }}</div>
          <div v-if="transaction.name">{{ transaction.company }}</div>
          <div v-if="transaction.name">{{ transaction.ident }}</div>
          <div v-if="transaction.name">{{ transaction.address }}</div>
          <div v-if="transaction.name">{{ transaction.zip }}</div>
          <div v-if="transaction.name">{{ transaction.city }}</div>
          <div v-if="transaction.name">{{ transaction.country }}</div>
          <div v-if="transaction.name">{{ transaction.phone }}</div>
          <div v-if="transaction.name">{{ transaction.email }}</div>
          <div v-else>{{ _('Johku App') }}</div>
          <h4>{{ $filters.currency(transaction.totalWithDelivery, settings.currency) }}</h4>
          <template v-if="transaction.more">
            <hr />
            <h4>{{ _('Additional info') }}</h4>
            <div>{{ transaction.more }}</div>
          </template>
          <template v-if="transaction.notes">
            <hr />
            <h4>{{ _('Notes') }}</h4>
            <div>{{ transaction.notes }}</div>
          </template>
        </div>
      </transition>
      <transition name="fade">
        <div v-show="items">
          <h4>{{ _('Items') }}</h4>
          <cart-item :readonly="true" :settings="shopSettings(shopId)" :shopId="shopId" :baseDomain="baseDomain" :locale="locale" :currItem="item" v-for="item in items.filter(i => !i.discount_id && !i.valuecard_id)" :key="item.id" leftcolwidth="0" rightcolwidth="12" context="page"></cart-item>
        </div>
      </transition>
      <transition name="fade">
        <div class="transactionlist-payments" v-show="payments">
          <h4>{{ _('Payments') }}</h4>
          <div class="js-cart-product row generic" v-for="payment in payments">
            <div class="js-cart-product-content col-md-12 match-row">
              <div class="product-name-wrap">
                <div class="js-cart-product-name">{{ getPaymentTitle(payment.method, payment) }}</div>
                <div class="js-cart-product-price">{{ $filters.currency(payment.amount, settings.currency) }}</div>
              </div>
              <div class="js-cart-product-unit">{{ DateTime.fromSeconds(Number(payment.paymentdate), { zone: timezone }).toFormat(dateFormat) }}</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade" v-if="hasConsolidatedOrders">
        <div class="transactionlist-consolidated">
          <h4>{{ _('Shared orders') }}</h4>
          <div class="js-cart-product row generic" v-for="co in transaction.ownConsolidatedOrder">
            <div class="js-cart-product-content col-md-12 match-row">
              <div class="product-name-wrap">
                <div class="js-cart-product-name">{{ _('Shop identifier') }}: {{ co.shop_id }}</div>
                <div class="js-cart-product-price">{{ $filters.currency(co.total, settings.currency) }}</div>
              </div>
              <button class="btn btn-default" v-if="co.local_bill_id" v-on:click="printRemoteReceipt(co)">{{ _('Print receipt') }}</button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="buttons transactionlist-actions flex-row space-between" v-show="transaction">
          <div class="flex-row">
            <div class="transaction-refund" v-if="(isRefunded || isRefund)"><span v-if="isRefunded">{{ _('Refunded') }}</span><span v-if="isRefund">{{ _('Refund') }}</span></div>
            <button class="btn btn-default" v-on:click="displayReceipt" v-if="isPrintable"><i class="fa fa-file fa-fw"></i> {{ _('Display receipt') }}</button>
            <button class="btn btn-default" v-on:click="printReceipt" v-if="isPrintable" :disabled="printing"><i class="fa fa-print fa-fw"></i> {{ _('Print receipt') }}</button>
            <button class="btn btn-default" v-on:click="printTickets" v-if="isPrintable && (hasTickets || hasValueCards)" :disabled="printing"><i class="fa fa-print fa-fw"></i> {{ printTicketsText }}</button>
            <template v-if="isResendBarVisible">
              <button v-if="hasValueCards" class="btn btn-default" type="button" v-on:click="resendValueCardEmailDialog"><i class="fa fa-fw fa-retweet"></i> {{ _('Resend value card email') }}</button>
              <button v-if="hasTickets" class="btn btn-default" type="button" v-on:click="resendTicketEmailDialog"><i class="fa fa-fw fa-retweet"></i> {{ _('Resend ticket email') }}</button>
            </template>
            <button :class="'btn btn-' + (refundClicked ? 'danger' : 'warning')" v-on:click="refundReceipt" v-if="isRefundable" :disabled="refunding"><i class="fa fa-fw fa-undo"></i> {{ refundClicked ? _('Confirm') : _('Refund receipt') }}</button>
          </div>
          <button class="btn btn-default" v-on:click="closeTransaction"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
        </div>
      </transition>
      <transition name="fade" v-if="hasConsolidatedOrders">
        <div style="margin-top: 20px">
          <i v-if="isNoLongerRefundable">{{ _('Refunding this receipt is no longer possible.') }}</i>
          <i v-else-if="!isRefunded">{{ _('Refunding this receipt will also refund all shared orders related to it.') }}</i>
        </div>
      </transition>
      <transition name="image" v-if="false">
        <div class="receipt-image" v-show="transaction">
          <img :src="this.baseDomain + this.shopId + '/posreceipts/' + this.transaction.identifier + '.png'" />
        </div>
      </transition>
    </div>
    <div class="transactions-container tinylist-container"  v-else>
      <transition name="fade">
        <div class="input-group">
          <input type="text" class="form-control" v-on:keyup="search" :placeholder="searchHint" v-model="searchStr" />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" v-on:click="clearSearch"><i class="fa fa-fw fa-trash"></i></button>
          </span>
        </div>
      </transition>
      <transition name="fade">
        <div class="transactions-items tinylist-items" v-show="transactions.length">
          <transaction-item v-for="(transaction, index) in transactions" :baseDomain="baseDomain" :key="transaction.id" :index="index" :transaction="transaction" v-on:transactionClicked="openTransaction(transaction)" v-on:notesClicked="displayNotes(transaction)"></transaction-item>
        </div>
      </transition>
      <transition name="fade">
        <div class="buttons button-row" v-show="transactions.length || start > 0">
          <button class="btn btn-default" :disabled="start === 0" v-on:click="loadPrevious">{{ _('Previous') }}</button>
          <button class="btn btn-default" :disabled="!(transactions.length >= limit)" v-on:click="loadNext">{{ _('Next') }}</button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  
import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import constants from '~/lib/constants'
import TransactionItem from '~/components/TransactionItem'
import CartItem from '~/components/CartItem'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'

export default {
  data () {
    return {
      DateTime: DateTime,
      transactions: [],
      transaction: null,
      items: null,
      payments: null,
      order: null,
      limit: 15,
      start: 0,
      printing: false,
      refundClicked: false,
      refunding: false,
      refundTimeout: false,
      searchStr: '',
    }
  },
  mixins: [components, constants],
  computed: {
    searchHint () {
      return this._('Type to search transactions')
    },
    printTicketsText () {
      if(this.hasTickets && !this.hasValueCards) {
        return this._('Print tickets')
      }
      if(!this.hasTickets && this.hasValueCards) {
        return this._('Print value cards')
      }
      if(this.hasTickets && this.hasValueCards) {
        return this._('Print tickets and value cards')
      }
    },
    isResendBarVisible () {
      return !this.isRefund && !this.isRefunded && (this.hasValueCards || this.hasTickets)
    },
    isPrintable () {
      if (!this.transaction) {
        return false
      }
      if (!parseInt(this.transaction.paid)) {
        return false
      }
      return true
    },
    isRefundable () {
      if (!this.transaction) {
        return false
      }
      if (parseInt (this.transaction.isrefund)) {
        return false
      }
      if (parseInt (this.transaction.refunded)) {
        return false
      }
      if (this.hasConsolidatedOrders) {
        if (this.isNoLongerRefundable) {
          return false
        }
      }
      return true
    },
    isNoLongerRefundable () {
      if(DateTime.now().diff(DateTime.fromSeconds(Number(this.transaction.orderdate), { zone: this.timezone }), 'hours').as('hours') > 2) {
        return true
      }
      return false
    },
    isRefunded () {
      if (parseInt (this.transaction.refunded)) {
        return true
      }
    },
    isRefund () {
      if (parseInt (this.transaction.isrefund)) {
        return true
      }
    },
    data () {
      return JSON.parse(this.component.data)
    },
    transactionFullDate () {
      let date = this.transaction.invoicedate
      if (!date) {
        date = this.transaction.orderdate
      }
      return DateTime.fromSeconds(Number(date), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + DateTime.fromSeconds(Number(date), { zone: this.timezone }).toFormat(this.timeFormat)
    },
    hasTickets () {
      if (!this.transaction || !this.items || !this.items.length) {
        return false
      }
      for (let i = 0; i < this.items.length; i++) {
        if (parseInt(this.items[i].product_subtype, 10) === this.SUBTYPE_TICKET) { // Ticket
          return true
        }
      }
      return false
    },
    hasValueCards () {
      if (!this.transaction || !this.items || !this.items.length) {
        return false
      }
      for (let i = 0; i < this.items.length; i++) {
        if (parseInt(this.items[i].product_subtype, 10) === this.SUBTYPE_VALUECARD || parseInt(this.items[i].product_subtype, 10) === this.SUBTYPE_EXCHANGED_VALUECARD) { // Value card subtypes
          return true
        }
      }
      return false
    },
    hasConsolidatedOrders () {
      return this.transaction && this.transaction.ownConsolidatedOrder && this.transaction.ownConsolidatedOrder.length
    }
  },
  methods: {
    search () {
      this.doSearch(this)
    },
    clearSearch () {
      this.searchStr = ''
      this.search()
    },
    doSearch: debounce (($this) => {
      $this.start = 0
      $this.loadTransactions()
    }, 250),
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    loadOrder (identifier) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/orders/' + identifier + '.json?apikey=' + this.apiKey)
        } catch (e) {
          reject()
          return
        }
        this.order = response.data
        resolve(this.order)
      })
    },
    loadTransactionsThrottled: throttle(function () { this.loadTransactions() }, 500, { leading: false, trailing: true }),
    loadTransactions () {
      let $this = this
      let searchQuery = ''
      if (this.searchStr) {
        searchQuery = '&sSearch=' + encodeURIComponent(this.searchStr)
      }
      axios.get(this.baseDomain + this.shopId + '/bills.json?iSortCol_0=0&iSortingCols=1&sSortDir_0=desc&iDisplayLength=' + this.limit + '&iDisplayStart=' + this.start + searchQuery + '&apikey=' + this.apiKey)
      .then(function (response) {
        $this.transactions = response.data
      })
      .catch(function () {
        console.log('Failed to load transactions.')
      })
    },
    openTransaction (transaction) {
      let $this = this
      let billArr = [
        axios.get(this.baseDomain + this.shopId + '/bills/' + transaction.id + '.json?details=true&apikey=' + this.apiKey),
        axios.get(this.baseDomain + this.shopId + '/bills/' + transaction.id + '/items.json?reservations=true&apikey=' + this.apiKey)
      ]
      axios.all(billArr)
      .then(axios.spread(function (billResponse, itemResponse) {
        $this.transaction = billResponse.data
        $this.payments = $this.transaction.ownPayment
        $this.items = itemResponse.data
        $this.loadOrder($this.transaction.identifier)
      }))
    },
    closeTransaction () {
      this.transaction = null
      this.payments = null
      this.items = null
      this.order = null
      this.refundClicked = false
      this.refunding = false
      this.printing = false
    },
    displayNotes (transaction) {
      this.EventBus.$emit('displayNotes', {
        type: 'bill',
        transaction: transaction
      })
    },
    displayReceipt () {
      if (!this.transaction || !this.transaction.id) {
        return
      }
      window.open(this.baseDomain + this.shopId + '/posreceipts/' + this.transaction.identifier + '.pdf')
    },
    printReceipt () {
      if (!this.transaction || !this.transaction.id) {
        return
      }
      this.printing = true
      axios.post(this.baseDomain + this.shopId + '/bills/' + this.transaction.id + '.json?print=receipt&pos=' + this.pos + '&client=' + this.clientid + '&apikey=' + this.apiKey, {
        id: this.transaction.id
      })
      .then(() => {
        this.printing = false
      })
      .catch((e) => {
        this.printing = false
        this.showError(e)
      })
    },
    printRemoteReceipt (co) {
      if (!co || !co.id) {
        return
      }
      this.printing = true
      axios.post(this.baseDomain + co.shop_id + '/bills/' + co.local_bill_id + '.json?print=receipt&shop=' + this.shopId + '&pos=' + this.pos + '&client=' + this.clientid, {
        id: co.local_bill_id
      })
      .then(() => {
        this.printing = false
      })
      .catch((e) => {
        this.printing = false
        this.showError(e)
      })
    },
    printTickets () {
      if (!this.transaction || !this.transaction.id) {
        return
      }
      this.printing = true
      axios.post(this.baseDomain + this.shopId + '/bills/' + this.transaction.id + '.json?print=tickets&pos=' + this.pos + '&client=' + this.clientid + '&apikey=' + this.apiKey, {
        id: this.transaction.id
      })
      .then(() => {
        this.printing = false
      })
      .catch((e) => {
        this.printing = false
        this.showError(e)
      })
    },
    resendValueCardEmailDialog () {
      this.showDialog({
        title: this._('Resend value card email'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Send email'),
            class: 'success',
            icon: 'send',
            requiredFields: ['email'],
            handler: this.resendValueCardEmail
          }
        ],
        fields: [
          {
            title: this._('Email'),
            type: 'email',
            name: 'email',
            defaultValue: this.order.email ? this.order.email : ''
          }
        ]
      })
    },
    resendValueCardEmail (params) {
      return new Promise(async (resolve, reject) => {
        this.showNotification(this._('Processing, please wait...'))
        let response
        const order = this.order
        try {
          const data = {
            id: order.id,
            overrideEmail: params.email
          }
          let versionStr = this.versionStr
          if (order.version) {
            versionStr = '&version=' + order.version
          }
          response = await axios.post(this.baseDomain + this.shopId + (this.versionStr ? '/' + this.version : '') + '/orders/' + order.id + '.json?resendvaluecards=true&apikey=' + this.apiKey + versionStr, data)
        } catch(e) {
          this.showError(e)
          return reject()
        }
        this.showNotification(this._('Message sent!'))
        resolve()
      })
    },
    resendTicketEmailDialog () {
      this.showDialog({
        title: this._('Resend ticket email'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Send email'),
            class: 'success',
            icon: 'send',
            requiredFields: ['email'],
            handler: this.resendTicketEmail
          }
        ],
        fields: [
          {
            title: this._('Email'),
            type: 'email',
            name: 'email',
            defaultValue: this.order.email ? this.order.email : ''
          }
        ]
      })
    },
    resendTicketEmail (params) {
      return new Promise(async (resolve, reject) => {
        this.showNotification(this._('Processing, please wait...'))
        let response
        const order = this.order
        try {
          const data = {
            id: order.id,
            overrideEmail: params.email
          }
          let versionStr = this.versionStr
          if (order.version) {
            versionStr = '&version=' + order.version
          }
          response = await axios.post(this.baseDomain + this.shopId + (this.versionStr ? '/' + this.version : '') + '/orders/' + order.id + '.json?resendtickets=true&apikey=' + this.apiKey + versionStr, data)
        } catch(e) {
          this.showError(e)
          return reject()
        }
        this.showNotification(this._('Message sent!'))
        resolve()
      })
    },
    refundReceipt () {
      if (!this.transaction || !this.transaction.id) {
        return
      }
      if (this.refundTimeout) {
        clearTimeout(this.refundTimeout)
      }
      if (!this.refundClicked) {
        this.refundClicked = true
        this.refundTimeout = setTimeout(() => {
          this.refundClicked = false
        }, 3000)
        return
      }
      this.refunding = true
      const postData = {
        identifier: this.transaction.identifier,
        refundconsolidated: true
      }
      axios.post(this.baseDomain + this.shopId + '/refunds/new.json?apikey=' + this.apiKey, postData)
      .then(() => {
        axios.delete(this.baseDomain + this.shopId + '/orders/' + this.transaction.identifier + '.json?apikey=' + this.apiKey)
        .then(() => {
          this.refunding = false
          this.refundClicked = false
          this.closeTransaction()
        })
        .catch((e) => {
          this.refunding = false
          this.refundClicked = false
          this.showError(e)
        })
      })
      .catch((e) => {
        this.refunding = false
        this.refundClicked = false
        this.showError(e)
      })
    },
    loadPrevious () {
      if (this.start >= this.limit) {
        this.start -= this.limit
      } else {
        this.start = 0
      }
      this.loadTransactions()
    },
    loadNext () {
      if (this.transactions.length >= this.limit) {
        this.start += 15
      }
      this.loadTransactions()
    },
    getPaymentTitle (type, payment) {
      if (payment) {
        if (payment.voucher) {
          return payment.voucher.name
        } else if (payment.valuecard) {
          return payment.valuecard.name
        }
      }
      switch (type) {
        case 'admincash':
        case 'cash':
          return this._('Cash')
        case 'admincard':
        case 'creditcard':
          return this._('Card') + (payment.bambora_id ? ' (ID: ' + payment.bambora_id + ')' : '')
        case 'voucher':
          return this._('Voucher')
        case 'billing':
        case 'bill':
          return this._('Billing')
        case 'transfer':
          return this._('Bank transfer')
        case 'mobilepay':
          return this._('MobilePay')
        case 'masterpass':
          return this._('MasterPass')
        case 'pivo':
          return this._('Pivo')
        case 'siirto':
          return this._('Siirto')
        case 'virtualcard':
          return this._('Virtual card')
        case 'open':
          return this._('Open order')
        case 'paybyway':
        case 'paybywaychannel':
        case 'bambora':
          return this._('Visma Pay')
        case 'netaxept':
          return this._('Netaxept')
        case 'paypal':
          return this._('PayPal')
        case 'verkkomaksut':
        case 'paytrail':
          return this._('Paytrail (legacy)')
        case 'checkout':
          return this._('Paytrail')
        case 'stripe':
          return this._('Stripe')
        case 'moni':
          return this._('MONI')
        case 'alipay':
          return this._('AliPay')
        case 'smartum':
          return this._('Smartum')
        case 'rounding':
          return this._('Rounding difference')
      }
      return type
    }
  },
  components: {
    CartItem,
    TransactionItem
  },
  mounted () {
    this.loadTransactions()
    if(!this.events) {
      let events = {}
      events['billUpdate'] = (message) => {
        this.loadTransactionsThrottled()
      }
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>

<style scoped>
.buttons {
  margin-top: 10px;
}
.receipt-image {
  margin-top: 10px;
}
</style>